import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { sendPostViewAnalytics } from '../transport';
import { ActionAfterViewObserver } from '../common/ActionAfterViewObserver';
import { trackBlockShow } from '../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export function withPostViewAnalytics(WrappedComponent, props, analyticsData) {
  var _analyticsData$banner;
  var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  var bannerSource = 'internal';
  var offerType = (_analyticsData$banner = analyticsData.banner.extra) === null || _analyticsData$banner === void 0 ? void 0 : _analyticsData$banner.offerType;
  var isShowed = false;
  var ComponentWithPostViewAnalytics = function ComponentWithPostViewAnalytics() {
    var onView = function onView() {
      if (!isShowed && !analyticsData.trackShowOncePerPage) {
        sendPostViewAnalytics(_objectSpread(_objectSpread({}, analyticsData), {}, {
          bannerSource: bannerSource,
          offerType: offerType
        }), 'show');
        isShowed = true;
      }
      if (analyticsData.trackShowOncePerPage) {
        trackBlockShow({
          analyticsData: analyticsData,
          bannerSource: bannerSource,
          offerType: offerType
        });
      }
    };
    var onClick = function onClick() {
      sendPostViewAnalytics(_objectSpread(_objectSpread({}, analyticsData), {}, {
        bannerSource: bannerSource,
        offerType: offerType
      }), 'click');
    };
    return /*#__PURE__*/_jsx(ActionAfterViewObserver, {
      callback: onView,
      percentVisible: 0.5,
      triggerOnce: true,
      children: /*#__PURE__*/_jsx("div", {
        onClick: onClick,
        children: /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, props))
      })
    });
  };
  ComponentWithPostViewAnalytics.displayName = "withPostViewAnalytics(".concat(displayName, ")");
  return ComponentWithPostViewAnalytics;
}